import { httpManager as http } from '@/common/js/HttpManager';

class Lab {

    async getLabInfo () {

        let result = await http.httpRequest({

            method: `GET`,
            url: `/lab/features/`

        });

        // 目前只有一个实验室，默认只取第一个
        return result.data[0];

    }

    async applyLab ( id ) {

        let data = await http.httpRequest({

            method: `PUT`,
            url: `/lab/features/${id}/`,
            data: {
                enabled: true
            }

        });

        return data.data;

    }

    async cancelLab ( id ) {

        let data = await http.httpRequest({

            method: `PUT`,
            url: `/lab/features/${id}/`,
            data: {
                enabled: false
            }

        });

        return data.data;

    }

}

export default new Lab();



// WEBPACK FOOTER //
// ./src/api/lab.js